export const getFileTypeFromBase64 = (base64String: string) => { 
  const mimeType = base64String.startsWith('/9j') // JPEG signature
    ? 'image/jpeg'
    : base64String.startsWith('iVBORw') // PNG signature
    ? 'image/png'
    : base64String.startsWith('AAAA') || base64String.startsWith('QVZN') // HEIF/HEVC signatures
    ? 'image/heif' // or 'image/heic' 
    : 'application/pdf'; // Default fallback
  return mimeType;
};